import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { DocumentationOnboardStatus } from './components'
import { useAuthAccount } from '~/store/auth/useAuthAccount'
import {
  hasDeniedAccountStatus,
  hasPendenciesInAnalysis,
  hasAnalysisAccountStatus,
  hasApprovedAccountStatus,
  hasInitialAnalysisStatus,
  hasPreApprovedAccountStatus,
  hasPendingCompleteDataStatus,
  hasRequiredPendenciesAccountStatus,
  hasRequiredNewCustomerAccountStatus,
  hasRequiredDocumentationAccountStatus
} from '~/utils/analysisStatus'

export const DocumentationOnboardStepsStatus: React.FC = () => {
  const { pjAnalysisStatus } = useAuthAccount()
  const { status } = pjAnalysisStatus

  const isDenied = hasDeniedAccountStatus(status)
  const isApproved = hasApprovedAccountStatus(status)
  const isInAnalysis = hasAnalysisAccountStatus(status)
  const iPreApproved = hasPreApprovedAccountStatus(status)
  const isInInitialAnalysis = hasInitialAnalysisStatus(status)
  const hasPendenciesInAnalysisStatus = hasPendenciesInAnalysis(status)
  const isNewAccount = hasRequiredNewCustomerAccountStatus(status)
  const hasPendencies = hasRequiredPendenciesAccountStatus(status)
  const isPendingCompleteData = hasPendingCompleteDataStatus(status)
  const isPendingAllDocumentation = hasRequiredDocumentationAccountStatus(status)

  return (
    <Box>
      <Typography variant='airbnbH5'>Etapas da solicitação</Typography>
      <Box>
        <DocumentationOnboardStatus
          isExact
          label='Cadastro'
          error={isDenied}
          success={!isInInitialAnalysis}
          waiting={isInInitialAnalysis}
          path={(isInAnalysis || isDenied) ? '/app/loan-request/feedback' : ''}
        />
        <DocumentationOnboardStatus
          label='Pré proposta'
          warning={iPreApproved}
          path='/app/loan-request/pre-proposal'
          success={!iPreApproved && !isNewAccount && !isDenied}
        />
        <DocumentationOnboardStatus
          isExact
          label='Completar Dados'
          warning={isPendingCompleteData}
          success={!isPendingCompleteData && !isNewAccount && !iPreApproved && !isDenied}
          path='/app/loan-request/complete-account'
        />
        <DocumentationOnboardStatus
          label='Documentos'
          success={(isInAnalysis || hasPendenciesInAnalysisStatus || isApproved) && !isDenied}
          warning={isPendingAllDocumentation || hasPendencies}
          path={hasPendencies ? '/app/loan-request/pendencies' : '/app/loan-request/documentation'}
        />
        <DocumentationOnboardStatus
          label='Em validação'
          validating={isInAnalysis || hasPendenciesInAnalysisStatus}
          success={isApproved && !isDenied}
          path={(hasPendenciesInAnalysisStatus || isApproved || isDenied) ? '/app/loan-request/pendencies' : '/app/loan-request/feedback'}
        />
        <DocumentationOnboardStatus
          isExact
          label='Crédito liberado'
          success={isApproved}
          path={isDenied ? '/' : '/app/loan-request/feedback'}
        />
      </Box>
    </Box>
  )
}
